export const SUBSCRIPTIONS_RESET_STATE = 'SUBSCRIPTIONS_RESET_STATE';
export const SUBSCRIPTIONS_CURRENT_ITEM = 'SUBSCRIPTIONS_CURRENT_ITEM';

export const SUBSCRIPTIONS_REQUEST_LOADING = 'SUBSCRIPTIONS_REQUEST_LOADING';
export const SUBSCRIPTIONS_REQUEST_SUCCESS = 'SUBSCRIPTIONS_REQUEST_SUCCESS';
export const SUBSCRIPTIONS_REQUEST_FAILED = 'SUBSCRIPTIONS_REQUEST_FAILED';

export const SUBSCRIPTIONS_CURRENT_ACTION = 'SUBSCRIPTIONS_CURRENT_ACTION';
export const SUBSCRIPTIONS_RESET_ACTION = 'SUBSCRIPTIONS_RESET_ACTION';
